export default [{ name: "Male" }, { name: "Female" }];
